import React, {useEffect, useState} from 'react'
import styled from 'styled-components'

import Link from "next/link";


const HeadWrapper = styled.div`
    max-width: 1200px;
    margin: 0 auto;
`

const StyledTopTop = styled.div`
border: 1px solid black;
>*{display: flex;
justify-content: flex-end;}
transition: all .3s ease;
position: fixed;
z-index: 2;
width: 100%;
    @media (max-width: 640px) {
      ${props => props.showMenuMob ? 'opacity: 1;visibility:1;' : 'opacity: 0;visibility:0;'};
       position: static;
       flex-direction: column;
    }


`

const Icon = styled.div`
 flex-grow: 1;
 padding: .3em;
 transition: all .3s ease;
    @media (max-width: 640px) {
      ${props => props.showMenuMob ? 'opacity: 1;visibility:1;' : 'opacity: 0;visibility:0;'};
     // position: fixed;
      color: red;
      z-index: 2;
      top:1em;
      left:1em;
      }
`


const TopTopButton = styled.div`
  background: rgba(0,0,0,0.8);
  a { color: white;}
  border: 2px solid white;
  padding: .3em;
  @media (max-width: 640px) {
      width: 100%;
  }
  
`



export default props => {
    return (
        <StyledTopTop showMenuMob={props.showMenuMob}>
            <HeadWrapper>
            <Icon showMenuMob={props.showMenuMob}>Icon</Icon>
            <TopTopButton>
                <Link><a>Social Media Link 1</a></Link>
            </TopTopButton>
            <TopTopButton>
                <Link><a>Social Media Link 2</a></Link>
            </TopTopButton>
            </HeadWrapper>
        </StyledTopTop>
    )

}